module.exports = __webpack_public_path__ + "static/media/Picture12.f01045dc.jpg";